import React, { useEffect } from 'react';
import useSWR from 'swr';
import {
  IDataType,
  SisDataGrid,
  SisDataGridColumns,
} from '../../../../components/table/SisDataGrid';
import { useTranslation } from '../../../../contexts/translation';
import { API_URL, fetcher } from '../../../../utils/apiUrl';
import { swrConfig } from '../../AssetsEdit';

interface AssetTabCycleStepsProps {
  cycleId: number;
  active: boolean;
}

export function AssetTabCycleStepsHistory(props: AssetTabCycleStepsProps) {
  const transFormName = 'Asset.Cycle.History';
  const { translate } = useTranslation();

  const { data: stepsHistory, mutate: mutateStepsHistory } = useSWR(
    `${API_URL.ASSET_CYCLE_HISTORY_LIST}?parentId=${props.cycleId}`,
    fetcher,
    swrConfig,
  );

  useEffect(() => {
    if (props.active) mutateStepsHistory();
  }, [props.active]);

  // Kontrola, jestli se jedná o měsíční cycle
  const { data: isCycleMonthly } = useSWR<boolean>(
    `${API_URL.ASSET_CYCLE_IS_CYCLE_MONTHLY}?parentId=${props.cycleId}`,
    fetcher,
    swrConfig,
  );

  const Columns = (isCycleMonthly): SisDataGridColumns => [
    {
      dataField: 'stepName',
      caption: 'Step name',
      dataType: IDataType.string,
      width: '30%',
    },
    {
      dataField: 'stepCapacityCategory',
      caption: 'Capacity category',
      dataType: IDataType.string,
      width: '10%',
    },
    {
      dataField: 'actionTranslated',
      caption: 'Action',
      dataType: IDataType.string,
      width: '30%',
    },
    {
      dataField: 'frequency',
      caption: 'Frequency',
      dataType: IDataType.number,
      width: '10%',
      cellRender: (cell) => {
        if (isCycleMonthly) {
          switch (cell.data.frequency) {
            case 1:
              return <>{translate!('Monthly', 'Asset.CycleStep')}</>;
            case 3:
              return <>{translate!('Quarterly', 'Asset.CycleStep')}</>;
            case 6:
              return <>{translate!('Semi-annually', 'Asset.CycleStep')}</>;
            case 12:
              return <>{translate!('Annually', 'Asset.CycleStep')}</>;
          }
        }
        return <>{cell.data.frequency}</>;
      },
    },
    {
      dataField: 'created',
      caption: 'Created',
      dataType: IDataType.dateTime,
      width: '10%',
    },
    {
      dataField: 'createdByName',
      caption: 'Created by',
      dataType: IDataType.string,
      width: '10%',
    },
  ];

  return (
    <>
      <SisDataGrid
        data={stepsHistory}
        keyExpr={'id'}
        transFormName={transFormName}
        columns={Columns(isCycleMonthly)}
        rowAlterantionEnabled
        columnChooser={false}
        allowColumnResizing={false}
        allowColumnReordering={false}
        enableGrouping
        disableGroupPanel
      />
    </>
  );
}
